// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../node_modules/css-loader/index.js??ref--4-oneOf-1-1!../node_modules/postcss-loader/src/index.js??ref--4-oneOf-1-2!../node_modules/less-loader/dist/cjs.js??ref--4-oneOf-1-3!./user.less");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("5aad296b", content, true, {});